var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.33 17.287c.167-1.239.17-2.888.17-5.287 0-2.4-.003-4.048-.17-5.286-.16-1.196-.448-1.782-.855-2.189-.407-.407-.993-.695-2.189-.855C16.049 3.503 14.4 3.5 12 3.5c-2.4 0-4.048.003-5.286.17-1.196.16-1.782.448-2.189.855-.407.407-.695.993-.855 2.189C3.503 7.952 3.5 9.6 3.5 12c0 2.4.003 4.048.17 5.287.16 1.195.448 1.78.855 2.188.407.407.993.695 2.189.855 1.238.167 2.887.17 5.286.17 2.4 0 4.048-.003 5.287-.17 1.195-.16 1.78-.448 2.188-.855.407-.407.695-.993.855-2.189ZM3.464 20.535C4.93 22 7.286 22 12 22c4.714 0 7.071 0 8.535-1.465C22 19.072 22 16.714 22 12s0-7.071-1.465-8.536C19.072 2 16.714 2 12 2S4.929 2 3.464 3.464C2 4.93 2 7.286 2 12c0 4.714 0 7.071 1.464 8.535Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.75 8.757C4.75 6.494 6.704 4.75 9 4.75c2.296 0 4.25 1.744 4.25 4.007 0 2.027-1.246 4.418-3.315 5.302a2.388 2.388 0 0 1-1.87 0c-2.07-.884-3.315-3.275-3.315-5.302ZM9 6.25c-1.57 0-2.75 1.172-2.75 2.507 0 1.544.988 3.318 2.405 3.923a.888.888 0 0 0 .69 0c1.417-.605 2.405-2.38 2.405-3.923 0-1.335-1.18-2.507-2.75-2.507Zm13.137-.387a.75.75 0 0 1 0 1.06L15.061 14l5.97 5.97a.75.75 0 0 1-1.06 1.06L14 15.06l-7.076 7.076a.75.75 0 1 1-1.06-1.06L21.076 5.862a.75.75 0 0 1 1.06 0Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.e7a7b3b246d34530cba94e882a8ce576.svg";
export { ForwardRef as ReactComponent };